import React from 'react';
import { pharmaPartnersData } from '../data/mock';

const PharmaPartners = () => {
  return (
    <section id="partners" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
            {pharmaPartnersData.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {pharmaPartnersData.subtitle}
          </p>
        </div>

        {/* Partners Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6">
          {pharmaPartnersData.partners.map((partner, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-6 flex items-center justify-center hover:shadow-lg hover:bg-white transition-all duration-300 border border-gray-200 hover:border-gray-300"
            >
              <div className="text-center">
                <div className="w-full h-16 flex items-center justify-center mb-2">
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className="max-w-full max-h-full object-contain opacity-70 hover:opacity-100 transition-opacity duration-200"
                  />
                </div>
                <p className="text-sm font-semibold text-gray-700">{partner.name}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Statement */}
        <div className="mt-16 bg-gradient-to-r from-gray-50 to-white rounded-2xl p-8 border border-gray-200">
          <div className="max-w-3xl mx-auto text-center space-y-4">
            <h3 className="text-2xl font-bold text-gray-900">
              Partnered with Industry Leaders
            </h3>
            <p className="text-gray-600 leading-relaxed">
              We work directly with top-tier pharmaceutical manufacturers to ensure 
              you receive genuine, high-quality medications. Our partnerships span across 
              India and internationally, giving us access to a comprehensive range of 
              authentic generic medications.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PharmaPartners;
